function Cross(){
  return (
    <div className="clickable__totem clickable__totem--cross"></div>
  )
}

export default Cross;
